import { Component, OnInit } from '@angular/core';

import { SettingsService } from 'src/app/services/settings.service';
import { UpdateService } from 'src/app/services/update.service';
@Component({
  selector: 'app-splash',
  templateUrl: './splash.page.html',
  styleUrls: ['./splash.page.scss'],
})
// custom splash screen. We use it because "default splash screen" doesn't seem to work in browser
// may be we will not use it later
export class SplashPage implements OnInit {

  constructor(
    public settings: SettingsService,
    private update: UpdateService    
  ) { 
    this.settings.log(1,'SplashPage constructor');
  }

  ngOnInit() {
    let t = this;
    let s = this.settings;    
    this.settings.log(1,'ngOnInit SplashPage');
    this.update.pageIsReady('SplashPage').then((result) => {
      this.settings.log(1,'SplashPage s.appType=' + s.appType + ' s.userAuthenticated=' + s.userAuthenticated + ' s.userAuthorised=' + s.userAuthorised());
      if (s.appType == 'public' || s.userAuthenticated) {
        s.openPage('/home');
      } else {
        s.userAuthorised().then((authorised:boolean)=>{
          if (authorised) {
            s.openPage('/login');
          } else {
            s.openPage('/authorise-email');
          }
        });
      }  
    }).catch((error)=>{
      this.settings.log(1,"SplashPage pageIsReady error " + error.message);
    });     
  }

    /*
  ionViewWillEnter() {
    let t = this;
    let s = this.settings;    
    this.settings.log(1,'ionViewWillEnter SplashPage');
    this.update.pageIsReady('SplashPage').then((result) => {
      this.settings.log(1,'SplashPage s.appType=' + s.appType + ' s.userAuthenticated=' + s.userAuthenticated + ' s.userAuthorised=' + s.userAuthorised());
      if (s.appType == 'public' || s.userAuthenticated) {
        s.openPage('/home');
      } else {
        s.userAuthorised().then((authorised:boolean)=>{
          if (authorised) {
            s.openPage('/login');
          } else {
            s.openPage('/authorise-email');
          }
        });
      }  
    }).catch((error)=>{
      this.settings.log(1,"SplashPage pageIsReady error " + error.message);
    }); 
  }
	    */
}
